import { render, staticRenderFns } from "./DealerUsersEdit.vue?vue&type=template&id=60060234&scoped=true"
import script from "./DealerUsersEdit.vue?vue&type=script&lang=js"
export * from "./DealerUsersEdit.vue?vue&type=script&lang=js"
import style0 from "./DealerUsersEdit.vue?vue&type=style&index=0&id=60060234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60060234",
  null
  
)

export default component.exports